<template>
    <div class="notification">
        <p>Notams</p>
    </div>
</template>

<script>
    export default {
        name: "NotamsM"
    }
</script>

<style scoped>

</style>
